import { useState, useEffect } from 'react';
import BaseMarkdown from '@components/base/BaseMarkdown';
import useI18n, { LocaleTypes } from '@i18n';

import privacyEpnRU from './epn/content_ru.md';
import privacyEpnEN from './epn/content_en.md';
import privacyEpncpaEN from './epncpa/content_en.md';

const PRIVACY_MAP = {
    epn: {
        [LocaleTypes.ru]: privacyEpnRU,
        [LocaleTypes.en]: privacyEpnEN,
    },
    epncpa: {
        [LocaleTypes.ru]: privacyEpncpaEN,
        [LocaleTypes.en]: privacyEpncpaEN,
    },
};

const RulesMarkdown: React.FC = () => {
    const { locale } = useI18n();
    const [markdown, setMarkdown] = useState<string>('');

    useEffect(() => {
        if (locale === LocaleTypes.ru) {
            setMarkdown(PRIVACY_MAP[process.env.NEXT_PUBLIC_PROJECT_NAME].ru);
        } else {
            setMarkdown(PRIVACY_MAP[process.env.NEXT_PUBLIC_PROJECT_NAME].en);
        }
    }, [locale]);

    return <BaseMarkdown markdown={markdown} />;
};

export default RulesMarkdown;
